module.exports = "/_next/static/images/warning-5213431c53e40897fd898a31f8730aba.svg";